import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import Cookies from "js-cookie";

window.Alpine = Alpine;
window.Cookies = Cookies;
Alpine.plugin(focus);

/**
 * Cookie Plugin using Alpine
 * ------------------------------------
 * Default cookie name prefix is '_cookies_' you can changes this
 * by adding a parameter to the x-data eg. x-data="cookieConsent('_othername_')"
 * this customises it for each client.
 * 
 * Example
 * -------
 * Once we've setup the name we just need to check for {cookiename}
 * eg. document.addEventListener("__cookies__ok", function(event) { // Insert GA script here });
 * 
 */

document.addEventListener("alpine:init", () => {

	Alpine.data('cookieConsent', ( cookieName = '_cookies_' ) => ({
		elem: '.x-cc',
		show: false,
		cookiesAgreed: false,
		cookieName: cookieName,
		eventName: '__cookies__ok',
		labels: {
			// Not needed if using ACF
			title: 'Cookies',
			message: 'Hey we need cookies',
			buttons: {
				accept: 'Accept',
				deny: 'Deny'
			}
		},
		expires: 90,
		init() {
			this.show = !sessionStorage.getItem(this.cookieName) && !Cookies.get(this.cookieName);
			if( Cookies.get(this.cookieName) ) {
				this.cookiesAgreed = true;
				this.$dispatch( this.eventName );
			}
		},
		acceptCookies(){
			Cookies.set(this.cookieName, true, { expires: this.expires })
			this.$dispatch( this.eventName );
			this.show = false;
			this.cookiesAgreed = true;
		},
		refuseCookies( destroy = false ){
			sessionStorage.setItem(this.cookieName, false);
			this.show = false;
			if( destroy ){
				Cookies.remove( this.cookieName );
			}
		},
		get title() {
			return this.labels.title;
		},
		get message() {
			return this.labels.message;
		},
		get acceptLabel() {
			return this.labels.buttons.accept;
		},
		get denyLabel() {
			return this.labels.buttons.deny;
		}
	}));

});